import { QueryVariablePreprocessor } from './initialQueryVariableProcessors.types';
import { useCallback } from 'react';
import { SearchModel } from '../DataTableQuery.types';
import { useDataTableContext } from '../../DataTableContext';
import { isEmptyQueryOrSort } from './isEmptyQueryOrSort';

/**
 *  Retrieves the initial parameters from the URL or local storage.
 */
export function useInitialSearchParamsProcessor(): QueryVariablePreprocessor.Function {
  const { querySettings } = useDataTableContext();
  return useCallback(
    (prevResult) => {
      const result = prevResult?.result as SearchModel<any, any>;
      if (isEmptyQueryOrSort(result)) {
        return {
          result: {
            ...(querySettings?.initialState ?? {}),
            quickReportId: undefined
          },
          status: QueryVariablePreprocessor.Status.COMPLETED
        };
      }
      return {
        result,
        status: QueryVariablePreprocessor.Status.COMPLETED
      };
    },
    [querySettings]
  );
}
